import React from "react"
import { Facebook, Twitter, Instagram, Linkedin, Send } from "lucide-react"
import Logo from "../../assets/images/logo/hazer-logo.png"
import { Link } from "react-router-dom"

export default function Footer() {
  return (
    <footer className="bg-[#0A0F1C] text-white pt-20 pb-8 border-t border-slate-800">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Column 1: Brand & About */}
          <div className="space-y-6">
            <Link to="/" className="inline-block bg-white p-2 rounded-xl">
              <img src={Logo} alt="Hazer Logo" className="h-12 w-auto" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Hazer is the premium platform connecting homeowners with trusted, verified professionals for all home services. Quality guaranteed.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-primary transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-primary transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-primary transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-primary transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm">About Us</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-white transition-colors text-sm">Services</Link></li>
              <li><Link to="/jobs" className="text-slate-400 hover:text-white transition-colors text-sm">Find Jobs</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Top Services</h4>
            <ul className="space-y-4">
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">Electrician</a></li>
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">Plumbing</a></li>
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">AC Repair</a></li>
              <li><a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">Home Cleaning</a></li>
            </ul>
          </div>

          {/* Column 4: Newsletter */}
          <div>
            <h4 className="text-lg font-bold mb-6">Newsletter</h4>
            <p className="text-slate-400 text-sm mb-4">
              Subscribe to get the latest updates and exclusive offers.
            </p>
            <form className="relative">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="w-full bg-white/5 border border-white/10 rounded-[12px] h-[48px] px-4 text-sm text-white focus:outline-none focus:border-brand-primary transition-colors"
              />
              <button 
                type="button" 
                className="absolute right-1 top-1 h-[40px] w-[40px] bg-brand-primary rounded-[10px] flex items-center justify-center hover:bg-blue-600 transition-colors"
              >
                <Send className="w-4 h-4" />
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Hazer Global. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-slate-500 hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-slate-500 hover:text-white text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  )
}